import request from '../../../helpers/request';

const changeFlatAttachment = async ({ id, attachId, data }) => {
  return await request.put(
    `/HousingStock/address/${id}/attachment/${attachId}`,
    data,
    'При изменении данных документа произошла ошибка'
  );
};

export default changeFlatAttachment;
